import mappingPluginBuilder from "lib/mapping/sources/resolver";
import userStore from "data/userStore";

export const getMappingPlugins = (activeRecord, fluxContext) => {
    const sources = activeRecord.entityInfo.mappingSources;
    if (sources == null) return [];
    return sources.map(s => mappingPluginBuilder(s.pluginKey, {
        activeRecord,
        fluxContext,
        mapping: s,
        org: userStore.getActiveOrgKey(),
    }));
};



// WEBPACK FOOTER //
// ./app/data/selectors/entities.js